import React from 'react';
import T from 'prop-types';
import SearchIcon from '../icons/search-icon';

const SearchField = (props) => {
  return (
    <div className="filters__searchfield">
      <SearchIcon />
      <input
        className={props.className}
        placeholder={props.placeholder}
        type="text"
        value={props.value}
        onChange={(e) => props.changeHandler(e.target.value)}
      />
      {props.value.length > 0 && (
        <button
          aria-label="Rensa text"
          onClick={(e) => {
            e.preventDefault();
            props.changeHandler('');
          }}
          type="reset"
        >
          &times;
        </button>
      )}
    </div>
  );
};

SearchField.propTypes = {
  className: T.string,
  placeholder: T.string,
  value: T.string,
  changeHandler: T.func,
};
export default SearchField;
